import { authStore } from '@/stores/auth'
import { adasIqStore } from '@/stores/adasIq'
export default async (to, from, next) => {
  const store = authStore()
  // exit if we are allowing anonymous
  if (to.matched.some((record) => record.meta.allowAnonymous)) {
    next()
    return
  }
  // exit if they are not authenticated
  if (!store.token) {
    store.setPassthrough = to.path
    next('/login')
    return
  }
  // a session from before features existed has none stored yet
  if (store.features === null) {
    await store.loadFeatures()
  }
  // exit if they are not allowed by role or feature
  if (!store.isAllowed(to.path)) {
    next('/')
    return
  }
  // ADAS IQ only for users ADAS IQ says may use it
  if (to.path === '/adas-iq' && !(await adasIqStore().check())) {
    next('/')
    return
  }
  // allowed
  next()
}
